import { css } from '@emotion/react';
import ReactAliceCarousel from 'react-alice-carousel';

import { Box, Button, Container, Flex, Heading, Text } from '@brand/components';
import { useTheme } from '@brand/theme';

import { Rating as RatingEntity } from '@domain/entities';

import { Trans } from '@hoa/atoms';
import { StarRating } from '@hoa/molecules';

import { useTrade } from '@hoa/hooks';

import { CategoryRatingReview } from './CategoryRatingReview';

interface Props {
  rating: RatingEntity | undefined;
}

export const CategoryRating = (props: Props): JSX.Element => {
  const { tradePlural } = useTrade();
  const theme = useTheme();

  const score = Math.round((props.rating?.avg_score || 0) * 10) / 10;
  const carouselItemsFilter = props.rating?.reviews.filter(
    review => review.rating >= 4,
  );

  return (
    <Box as="section" py={20}>
      <Container>
        <Heading as="h2" variant="h3" textAlign="center" mb={10}>
          <Trans
            i18nKey="category:jobs.rating.title"
            components={{
              strong: <Heading as="strong" variant="h3" color="#c5163a" />,
            }}
            values={{ trade: tradePlural?.toLowerCase() }}
          />
        </Heading>
        <Box mb={4}>
          <StarRating score={score} />
        </Box>
        <Flex justifyContent="center" textAlign="center">
          <Box>
            <Heading as="span" variant="h4">
              {score}
            </Heading>
          </Box>
          <Box>
            <Text as="span">/5</Text>
          </Box>
        </Flex>
        <Box
          mt={8}
          css={css`
            .alice-carousel__dots-item {
              background-color: ${theme.colors.gray[`200`]};

              &.__active,
              &:hover {
                background-color: ${theme.colors.primary.base};
              }
            }
          `}
        >
          <ReactAliceCarousel
            autoWidth
            mouseTracking
            controlsStrategy="responsive"
            autoPlay
            animationDuration={600}
            autoPlayInterval={3000}
            infinite
            keyboardNavigation
            items={carouselItemsFilter?.map(review => {
              return (
                <Box key={review.id} pr={4} width="280px">
                  <CategoryRatingReview review={review} />
                </Box>
              );
            })}
            renderPrevButton={() => {
              return (
                <Button variant="outlineBlue" mr={2} fontSize="xl" mt={2}>
                  {'<'}
                </Button>
              );
            }}
            renderNextButton={() => {
              return (
                <Button variant="outlineBlue" fontSize="xl" mt={2}>
                  {'>'}
                </Button>
              );
            }}
          />
        </Box>
      </Container>
    </Box>
  );
};
